var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-danger"},[_c('button',{staticClass:"delete",attrs:{"value":true},on:{"click":_vm.onClose}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }